import $ from 'jquery';
import Modal from '@shopify/marketing-assets/javascripts/modules/modal';
import keycodes from '@shopify/marketing-assets/javascripts/global/keycodes';

class SeriesModal extends Modal {
  constructor($el, template, options) {
    const modalOptions = Object.assign(options, {
      isSeries: true,
      modalNavNextButtonSelector: '.modal-nav-next',
      modalNavPrevButtonSelector: '.modal-nav-prev',
    });

    super($el, template, modalOptions);

    this.$modalSource.off('click');
    this.$modalSource.off('keydown');

    this.$modalSource = this.$el.find(this.options.itemSelector);
    this.$activeSource = this.$modalSource;

    this.modalSeriesSize = this.$modalSource.length;
    this.$el = $el;

    this.$el.on('click', this.options.itemSelector, this._onClick);
  }

  open = function() {
    Modal.prototype.open.apply(this, arguments);

    this.modalDom.$modal.on('click', this.options.modalNavNextButtonSelector, this.nextItem);
    this.modalDom.$modal.on('click', this.options.modalNavPrevButtonSelector, this.prevItem);
  };

  close = function() {
    Modal.prototype.close.apply(this, arguments);

    this.modalDom.$modal.off('click', this.options.modalNavNextButtonSelector, this.nextItem);
    this.modalDom.$modal.off('click', this.options.modalNavPrevButtonSelector, this.prevItem);
  };

  to = function(index) {
    this.currentIndex = index;

    this.$activeSource = this.$modalSource.eq(this.currentIndex);

    this.$modalSource.removeClass(this.options.modalActiveSourceClass);

    // transitioning from another item in a modal series
    if (this.active) {
      this.modalDom.$modal.addClass('transition-out').removeClass('js-view-active').prepareTransition({eventOnly: true});
      this.modalDom.$modal.one('transitionended', this.render);
    } else {
      this.render();
    }

    this.$activeSource.addClass(this.options.modalActiveSourceClass);
    this.modalDom.$modal.focus();
  };

  render = () => {
    this.data = Object.assign(this.$activeSource.data(), this.options.data);

    const modalHTML = this.template(this.data);

    this.modalDom.$modal.html(modalHTML).removeClass('transition-out').prepareTransition({eventOnly: true});

    this.modalDom.$modal.one('transitionended', () => {
      this.modalDom.$modal.addClass('js-view-active');
    });

    this.picturefill();
  };

  prevItem = () => {
    const prevIndex = (this.currentIndex === 0 ? this.modalSeriesSize - 1 : (this.currentIndex - 1));
    this.to(prevIndex);
  };

  nextItem = () => {
    const nextIndex = (this.currentIndex === this.modalSeriesSize - 1 ? 0 : (this.currentIndex + 1));
    this.to(nextIndex);
  };

  _onClick = (evt) => {
    evt.preventDefault();

    this.$modalSource = this.$el.find(this.options.itemSelector);

    this.to(this.$modalSource.index($(evt.currentTarget)));
    this.open(evt);
  };

  _onKeyDown = function(evt) {
    if (this.active) {
      switch (evt.keyCode) {
        case keycodes.ESCAPE:
          this.close();
          break;
        case keycodes.LEFT:
          if (this.modalSeriesSize > 0) {
            this.prevItem();
          }
          break;
        case keycodes.RIGHT:
          if (this.modalSeriesSize > 0) {
            this.nextItem();
          }
          break;
        default:
          break;
      }
    }
  };

}

export default SeriesModal;
